import styled from 'styled-components';

export const Button = styled.button`
  display: inline-block;
  padding: 12px 24px;
  font-weight: 500;
  text-align: center;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 0.875rem;
`;

export const PrimaryButton = styled(Button)`
  background-color: var(--accent-2);
  color: var(--secondary);
  
  &:hover {
    background-color: #7a0000;
    transform: translateY(-2px);
  }
`;

export const SecondaryButton = styled(Button)`
  background-color: transparent;
  color: var(--secondary);
  border: 1px solid var(--secondary);
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
  }
`;

export const SectionTitle = styled.h2`
  position: relative;
  margin-bottom: var(--spacing-xl);
  text-transform: uppercase;
  text-align: center;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: var(--accent-2);
  }
`;

export const SectionContainer = styled.section`
  padding: var(--spacing-xxl) 0;
`;

export const Card = styled.div`
  background-color: var(--secondary);
  color: var(--primary);
  padding: var(--spacing-md);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: var(--spacing-md);
`;

export const FormField = styled.div`
  margin-bottom: var(--spacing-md);
  
  label {
    display: block;
    margin-bottom: var(--spacing-xs);
    font-weight: 500;
    color: var(--secondary);
  }
  
  input, textarea, select {
    width: 100%;
    padding: var(--spacing-sm);
    background-color: #f5f5f5;
    border: 1px solid var(--accent-1);
    color: var(--secondary);
    font-family: 'Inter', 'Helvetica', 'Arial', sans-serif;
    
    &:focus {
      outline: none;
      border-color: var(--accent-2);
      background-color: #ffffff;
    }
  }
  
  textarea {
    min-height: 150px;
  }
`; 